// extracted by mini-css-extract-plugin
module.exports = {"brand-section":"header__brand-section___5OQ2w","brand-link":"header__brand-link___RsYeP","small-service-logo":"header__small-service-logo___15Zs6"};